import { createSlice } from '@reduxjs/toolkit'

interface LoaderType {
    loader: boolean
}

const initialState: LoaderType = {
    loader: true,
}
const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        updateLoader(state, action) {
            state.loader = action.payload
        },
    },
})

export const { updateLoader } = loaderSlice.actions
export default loaderSlice.reducer
